import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter202 extends Component {
  render() {
    return (
      <div>

        <Header as='h1'>
        1. 二項分布の式
        </Header>
<p>
        　二項分布は成功確率<InlineMath>{`\\displaystyle p `}</InlineMath>の試行を <InlineMath>{`\\displaystyle N `}</InlineMath>回行い、その成功回数<InlineMath>{`\\displaystyle r `}</InlineMath>を確率変数とする確率分布の事です。一般的には以下の様な確率質量関数として定義されています。正規分布などの説明に用いられる確率密度関数ではなく、確率質量関数となっているのは<InlineMath>{`\\displaystyle r `}</InlineMath>が正の整数しか取らない離散値だからです。
</p>
  
        <BlockMath>{`

          \\begin{aligned} 
          x &= 1+1 \\\\ 
            &= 2 \\,\\,\\,\\, \\cdot\\cdot\\cdot \\,\\,\\,\\,  \\left(2\\right)
          \\end{aligned}

        `}</BlockMath>

        <BlockMath>{`

          \\begin{aligned} 
            \\int_0^\\infty x^2 dx &= \\frac{1}{x + 1} \\\\
            &= \\frac{x^2 + 2}{x - 1}
          \\end{aligned}

        `}</BlockMath>
      </div>
    )   
  }
}

export default Chapter202;
